import React from 'react';
import './SkeletonLoader.css';

/**
 * Skeleton cards for the sidebar material grid
 */
export const SkeletonGrid = ({ count = 8 }) => (
    <div className="skeleton-grid">
        {Array.from({ length: count }).map((_, i) => (
            <div className="skeleton-card" key={i}>
                <div className="skeleton-element skeleton-card-image" />
                <div className="skeleton-element skeleton-card-text" />
            </div>
        ))}
    </div>
);

/**
 * Skeleton for the sub-navigation tabs
 */
export const SkeletonSubNav = ({ count = 4 }) => (
    <div className="skeleton-subnav">
        {Array.from({ length: count }).map((_, i) => (
            <div className="skeleton-element skeleton-subnav-item" key={i} />
        ))}
    </div>
);

/**
 * Skeleton for the main scene/visualization area
 */
export const SkeletonScene = ({ hidden = false }) => (
    <div className={`skeleton-main-content ${hidden ? 'hidden' : ''}`}>
        <div className="skeleton-element skeleton-scene" />
    </div>
);

/**
 * Skeleton for the material details panel
 */
export const SkeletonDetails = () => (
    <div className="skeleton-details">
        <div className="skeleton-element skeleton-detail-image" />
        <div className="skeleton-element skeleton-detail-title" />
        <div className="skeleton-element skeleton-detail-subtitle" />
        <div className="skeleton-detail-divider" />
        {Array.from({ length: 4 }).map((_, i) => (
            <div className="skeleton-detail-row" key={i}>
                <div className="skeleton-element skeleton-detail-label" />
                <div className="skeleton-element skeleton-detail-value" />
            </div>
        ))}
        <div className="skeleton-detail-divider" />
        <div className="skeleton-element skeleton-detail-btn" />
    </div>
);
